import { companyOnboardingEnabled } from "@/config";
import { IdentitiesPath } from "@/screen/Identities/identitiesRoutes";

/**
 * Alta de empresas en desarrollo: sin REACT_APP_COMPANY_ONBOARDING_ENABLED=true (PRO) no se registran sus rutas ni
 * se enseña el botón de alta. Cualquier otro valor, también el marcador sin sustituir del pipeline, la desactiva.
 */
export const isCompanyOnboardingEnabled = (settingValue: string | undefined = companyOnboardingEnabled): boolean =>
    settingValue?.trim().toLowerCase() === "true";

// Rutas del alta de empresas: cuelgan de Gestión de Intervinientes porque la empresa es un interviniente más.
export const CompaniesPath = `${IdentitiesPath}/company`;
export const CompanyRepresentativeNewPath = `${CompaniesPath}/representative/new`;
export const CompanySubscriptionPath = `${CompaniesPath}/subscription`;
export const CompanyDetailsPath = `${CompaniesPath}/details`;
export const CompanyKycPath = `${CompaniesPath}/kyc`;

/** El id de la empresa viaja por el state de la navegación, no por la URL (igual que en la edición de intervinientes). */
export interface CompanyDetailsNavigationState
{
    companyIdentityId: number;
}
